import { defineComponent as _defineComponent } from 'vue'
import { useDisengageConfiguration } from '../templating/disengage/disengage';
import App from './App.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisengageWrapper',
  setup(__props) {

const disengagedTemplate = useDisengageConfiguration();

return { __sfc: true,disengagedTemplate, App }
}

})